import { requests } from "../../../../api/agent"

export default {
	create        : (params) => requests.post('/ReOrgStatusType/create', params),
	update        : (params) => requests.post('/ReOrgStatusType/update', params),
	delete        : (params) => requests.getWithParams('/ReOrgStatusType/delete', params),
	restore       : (params) => requests.getWithParams('/ReOrgStatusType/restore', params),
	getPaged      : (params) => requests.getWithParams('/ReOrgStatusType/getPaged', params),
	getPagedAudit : (params) => requests.getWithParams('/ReOrgStatusType/getPagedAudit', params),
	getPagedAll   : (params) => requests.getWithParams('/ReOrgStatusType/getPagedAll', params),
	getList       : (params) => requests.getWithParams('/ReOrgStatusType/getList', params)
}